module.exports = __webpack_public_path__ + "static/media/P2020.f2283cfe.3gp";


//////////////////
// WEBPACK FOOTER
// ./src/video/P2020.3gp
// module id = 445
// module chunks = 0